import "./Guatape.module.css";
import Header from "@/reusable_sections/Header";
import StunningGuatapeOverview from "./sections/StunningGuatapeOverview";
import ExclusiveExperiences from "./sections/ExclusiveExperiences";
import SignaturePartnerships from "./sections/SignaturePartnerships";
import ExperienceInquiry from "./sections/ExperienceInquiry";
import Footer from "@/reusable_sections/Footer";
export default function GuatapePage() {
  return <div>
      <Header />
      <StunningGuatapeOverview />
      <ExclusiveExperiences />
      <SignaturePartnerships />
      <ExperienceInquiry />
      <Footer />
    </div>;
}